module.exports = __webpack_public_path__ + "fonts/Gibson-Regular.2b5a7cea.eot";